import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        module: '.rfct-tab-bar',
        item: '.rfct-tab-bar__tabs-item',
        content: '.rfct-tab-bar__content',
    },
    classNames: {
        itemActive: 'rfct-tab-bar__tabs-item--active',
        contentActive: 'rfct-tab-bar__content--active',
    },
    dataAttributes: {
        index: 'index',
    },
};

export default class TabBar {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = this._getDomElements();
    }

    _getDomElements() {
        return {
            $items: this._$rootElement.find(config.selectors.item),
            $content: this._$rootElement.find(config.selectors.content),
        };
    }

    init() {
        this._addEventListeners();
    }

    _addEventListeners() {
        this._elements.$items.on('click', (e) => {
            const $element = $(e.currentTarget);
            const index = $element.data(config.dataAttributes.index);

            if (!$element.hasClass(config.classNames.itemActive)) {
                this._elements.$items.removeClass(config.classNames.itemActive);
                this._elements.$content.removeClass(config.classNames.contentActive);

                $element.addClass(config.classNames.itemActive);

                // find content element with same data-index
                const content = this._$rootElement.find(`${config.selectors.content}[data-index='${index}']`);
                content.addClass(config.classNames.contentActive);
            }
        });
    }
}

moduleRegistry.registerModule('TabBar', TabBar);
moduleRegistry.autoApplyModule('TabBar', config.selectors.module);
